import { Component, AfterViewInit, inject } from '@angular/core';
import { TranslatedService } from '@app/shared/services/translated.service';

@Component({
	selector: 'g-translated-strings',
	templateUrl: './translated-strings.component.html',
	styleUrls: ['./translated-strings.component.scss'],
	standalone: false,
})
export class TranslatedStringsComponent implements AfterViewInit {
	private readonly translated = inject(TranslatedService);

	ngAfterViewInit() {
		this.translated.initialize();
	}
}
